import { useState, useEffect, useCallback } from 'react';

const getDeviceConfig = (width: number) => {
  if (width >= 1300) {
    return 'xxl';
  } else if (width >= 1200) {
    return 'xl';
  } else if (width >= 992) {
    return 'lg';
  } else if (width >= 768) {
    return 'md';
  } else if (width >= 576) {
    return 'sm';
  } else {
    return 'xs';
  }
};

const useBreakpoint = (returnWidth = false) => {
  const getWidth = () =>
    typeof window !== 'undefined' ? window.innerWidth : 0;

  const [brkPnt, setBrkPnt] = useState(() =>
    returnWidth ? getWidth() : getDeviceConfig(getWidth()),
  );

  const calcInnerWidth = useCallback(() => {
    if (typeof window !== 'undefined') {
      setBrkPnt(
        returnWidth ? window.innerWidth : getDeviceConfig(window.innerWidth),
      );
    }
  }, [returnWidth]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', calcInnerWidth);
      // Cleanup function
      return () => window.removeEventListener('resize', calcInnerWidth);
    }
  }, [calcInnerWidth]);

  return brkPnt;
};

export default useBreakpoint;
